import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { DecisionNode } from 'lib/types/models';
import { Node } from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React from 'react';

import EQRangeAssign from '../EQRangeAssign';
import GTRangeAssign from '../GTRangeAssign';
import LTRangeAssign from '../LTRangeAssign';

type Props = {
  newNode: Node;
  addRange: () => void;
  handleChangeRange: (e: SelectChangeEvent<number>, index: number) => void;
  deleteRange: (index: number) => void;
  availableFinalNodeForSelection: () => DecisionNode[];
  setNewNode: (node: Node) => void;
  setOperation: (operation: string) => void;
  operation: string;
};

const RangesAssign = (props: Props) => {
  const {
    newNode,
    addRange,
    handleChangeRange,
    deleteRange,
    availableFinalNodeForSelection,
    setNewNode,
    setOperation,
    operation,
  } = props;

  const handleChangeOperation = (e: SelectChangeEvent<string>) => {
    const { value } = e.target;
    setOperation(value);
    setNewNode({ ...newNode, operation: value, ranges: [] });
  };

  const handleChangeBoolean = (e: SelectChangeEvent<number>) => {
    const { value } = e.target;
    const { name } = e.target;
    const ranges = newNode.ranges.map((x, i) => {
      if (i === (name === 'correct' ? 1 : 0)) {
        return { ...x, nodeId: Number(value) };
      }
      return x;
    });
    setNewNode({ ...newNode, operation: 'eq', ranges });
  };

  if (newNode.type === 'boolean')
    return (
      <div>
        <Typography variant="body1" gutterBottom>
          <b>Opciones</b>
        </Typography>
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel id="filter-label">
            {' '}
            Cuando se cumple la evaluación asignar
          </InputLabel>
          <Select
            labelId="filter-label"
            id="Filtrar por estado"
            name="correct"
            margin="dense"
            value={newNode.ranges[1]?.nodeId}
            onChange={handleChangeBoolean}
            label="Cuando se cumple la evaluación asignar"
          >
            {availableFinalNodeForSelection().map((x, index) => (
              <MenuItem key={index} value={x.id}>
                {x.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel id="filter-label">
            {' '}
            Cuando no se cumple la evaluación asignar
          </InputLabel>
          <Select
            labelId="filter-label"
            id="Filtrar por estado"
            name="incorrect"
            value={newNode.ranges[0]?.nodeId}
            onChange={handleChangeBoolean}
            label="Cuando no se cumple la evaluación asignar"
          >
            {availableFinalNodeForSelection().map((x, index) => (
              <MenuItem key={index} value={x.id}>
                {x.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  return (
    <div>
      <div>
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel id="filter-label">Operación</InputLabel>
          <Select
            labelId="filter-label"
            id="Filtrar por estado"
            name="operation"
            value={operation}
            onChange={handleChangeOperation}
            label="Operación"
          >
            <MenuItem value="gt">Mayor a menor</MenuItem>
            <MenuItem value="lt">Menor a mayor</MenuItem>
            <MenuItem value="eq">Igual a</MenuItem>
          </Select>
        </FormControl>
      </div>
      {operation === 'eq' && (
        <EQRangeAssign
          newNode={newNode}
          addRange={addRange}
          handleChangeRange={handleChangeRange}
          deleteRange={deleteRange}
          availableFinalNodeForSelection={availableFinalNodeForSelection}
        />
      )}
      {operation === 'gt' && (
        <GTRangeAssign
          newNode={newNode}
          addRange={addRange}
          handleChangeRange={handleChangeRange}
          deleteRange={deleteRange}
          availableFinalNodeForSelection={availableFinalNodeForSelection}
        />
      )}
      {operation === 'lt' && (
        <LTRangeAssign
          newNode={newNode}
          addRange={addRange}
          handleChangeRange={handleChangeRange}
          deleteRange={deleteRange}
          availableFinalNodeForSelection={availableFinalNodeForSelection}
        />
      )}
    </div>
  );
};

export default RangesAssign;
